import dateFormat from '../../../procedures/date-format';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api from './api';
import topRightActions from './top-right-section';

const options = {
  paymentInTime: {
    label: 'W terminie płatności',
    value: 0,
    color: 'success',
  },
  paymentPartiallyPaid: {
    label: 'Niedopłata',
    value: 1,
    color: 'warning',
  },
  paymentRequired: {
    label: 'Zaległość',
    value: 2,
    color: 'danger',
  },
};

export default {
  actions,
  topRightActions,
  api,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    invoiceNumber: column({
      label: 'Numer faktury',
      format: item => item.invoicenumber.formatted_val,
    }),
    crm: column({
      label: 'Kontrahent',
      format: item => item.crm.client.person.company.name ?? '-',
    }),
    nip: column({
      label: 'NIP',
      format: item => item.crm.client.person.company.nip ?? '-',
    }),
    issue_date: column({
      label: 'Data wystawienia',
    }),
    _dueDate: column({
      label: 'Data płatności',
    }),
    _delayInDays: column({
      label: 'Ilość dni zaległości',
    }),
    total_gross_amount: column({
      label: 'Kwota brutto',
    }),
    _leftToPay: column({
      label: 'Pozostało do zapłaty',
    }),
    _status: column({
      label: 'Status',
      component: 'value-status',
      options,
    }),
  },
  vars: vars({
    noItemsText: 'Brak faktur',
    sidebarLabel: 'Podgląd faktury',
    divideFormatter: ({ item: { issue_date } }) => dateFormat(issue_date, 'LLLL yyyy'),
  }),
};
